/*---------------------------------------------------------------------------------------------
* Copyright (c) Bentley Systems, Incorporated. All rights reserved.
* See LICENSE.md in the project root for license terms and full copyright notice.
*--------------------------------------------------------------------------------------------*/

import { ExtensionClient } from "./ExtensionClient";

export * from "./types";
export * from "./ExtensionClient";
export * from "./ServiceExtensionProvider";
export default ExtensionClient;
